var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 125.000000 131.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,131.000000) scale(0.100000,-0.100000)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#776e03",
    d: "M333 1239 c-82 -10 -149 -41 -200 -91 -83 -82 -103 -176 -103 -493 0 -323 20 -415 109 -498 26 -24 74 -55 107 -68 58 -24 64 -24 379 -24 313 0 321 1 380 24 81 32 155 106 185 186 21 55 23 81 28 310 7 371 -11 471 -100 562 -51 52 -116 81 -210 93 -87 11 -487 11 -575 -1z m608 -110 c71 -15 133 -73 154 -142 21 -73 22 -591 0 -663 -19 -64 -75 -120 -140 -140 -71 -21 -590 -20 -662 1 -69 21 -127 83 -142 154 -15 69 -15 563 0 632 16 72 75 136 144 154 64 17 570 20 646 4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#776e03",
    d: "M891 1014 c-27 -35 -26 -59 4 -89 27 -28 45 -31 78 -14 29 16 37 28 37 62 0 63 -80 90 -119 41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#776e03",
    d: "M555 951 c-84 -22 -163 -88 -206 -171 -33 -65 -33 -185 0 -254 31 -63 84 -116 147 -147 70 -34 188 -34 258 0 63 31 116 84 147 147 33 69 34 189 1 256 -30 61 -90 120 -150 148 -51 24 -147 34 -197 21z m161 -121 c62 -31 97 -87 102 -166 4 -55 1 -69 -22 -108 -78 -133 -272 -131 -344 4 -33 63 -28 150 12 208 53 78 163 104 252 62z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b8a2bad8776d7847052d14f45e746201.svg";
export { ForwardRef as ReactComponent };